import { inject, Optional, Pipe, PipeTransform } from '@angular/core'
import dayJS from 'dayjs'
import localeData from 'dayjs/plugin/localeData'
import { I18nService } from '@wm-front/core'

dayJS.extend(localeData)
@Pipe({
  name: 'ordinal',
  standalone: true,
})
export class OrdinalPipe implements PipeTransform {
  protected _i18nService = inject(I18nService)

  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(@Optional() protected i18nService: I18nService) {
    if (i18nService) {
      this._i18nService = i18nService
    }
  }

  /** tranforms number into ordinal
   * @param { number }
   * @returns { string }
   */
  public transform(number: number | string): string {
    if (isNaN(Number(number))) {
      return number.toString()
    }

    number = Number(number)

    /** Make hack
     * Replace this typescript hack when issue is closed on dayjs repo
     * https://github.com/iamkun/dayjs/issues/1922
     */
    const ordinal = (
      dayJS()
        .locale(this._i18nService.language || 'en-gb')
        .localeData() as any
    )
      .ordinal(number)
      .replace(number.toString(), '')
      .replace(/\[/g, '')
      .replace(/]/g, '')
      .sup()

    /** @TODO
     *  You can remove this hack when this PR https://github.com/iamkun/dayjs/pull/1932 was validate
     */
    let fixOrdinalDayJs = ''
    if (this._i18nService.language?.includes('fr')) {
      fixOrdinalDayJs = number > 1 ? 'e'.sup() : ''
    }
    return `${number}${ordinal}${fixOrdinalDayJs}`
  }
}
